import React from 'react';
import { Benefits } from '../components/Benefits';
import { Blog } from '../components/Blog';
import { Hero } from '../components/Hero';

export const HomePage = () => {
  return (
    <>
      <Hero />
      <Benefits />
      <Blog />
    </>
  );
};